import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import './ProfileDisplay.css';

function ProfileDisplay({ instructor, instructor_title, instructor_photo }) {
  return (
    <div className='profile-display-contain'>
      {instructor_photo ? (
        <Avatar 
          src={instructor_photo} 
          size={64}
          className="instructor-avatar"
        />
      ) : (
        <Avatar 
          icon={<UserOutlined />} 
          size={32}
          className="instructor-avatar"
          style={{ backgroundColor: '#f56a00' }}
        />
      )}
      <div className='gray-contain-label'>
        <span className='commentor-name'>{instructor}</span>
        <span className='commentor-title'>{instructor_title}</span>
      </div>
    </div>
  );
}

export default ProfileDisplay;